import { Spinner } from '@/components/ui/spinner';

interface ApiLoaderProps {
  show: boolean;
  text?: string;
  overlay?: boolean;
}

export function ApiLoader({ show, text, overlay = false }: ApiLoaderProps) {
  if (!show) {
    return null;
  }

  const containerClass = overlay
    ? 'absolute inset-0 z-[100] flex items-center justify-center'
    : 'flex items-center justify-center py-8';

  return (
    <div className={containerClass}>
      <div className="flex flex-col items-center gap-2">
        <Spinner className="size-10 text-green-500" />
        {text ? <p className="text-xs text-muted-foreground">{text}</p> : null}
      </div>
    </div>
  );
}
